import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propChildren, propFunc, propId, propStr, } from '../../../../helpers/custom-prop-types';
import HtmlLink from '../../Common/HtmlLink';
const ProfessionalCardLink = (props) => {
    const { children, className, id, isPre, showPreModal } = props;
    return (_jsx(HtmlLink, Object.assign({ className: clsx('ui-professional-card-link', className), isNoLinkComponent: isPre ? 'button' : undefined, onClickNoLink: showPreModal, target: '_blank', to: `/consultant/${id}`, type: isPre ? 'button' : undefined }, { children: children })));
};
ProfessionalCardLink.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    id: propId().isRequired,
    isPre: propBool().isRequired,
    showPreModal: propFunc().isRequired,
};
ProfessionalCardLink.defaultProps = {
    className: '',
};
export default ProfessionalCardLink;
